@if (notificationService.hasError) {
  <div class="mat-elevation-z2 alert-error" style="margin: 16px 0; padding: 16px; border-radius: 4px; position: relative;">
    <div class="d-flex align-items-center flex-gap-1">
      <mat-icon class="error">error</mat-icon>
      <div>
        <div><strong>Unfortunately we have experienced an error</strong></div>
        <div>{{ notificationService.errorMessage }}</div>
      </div>
    </div>
    <button mat-icon-button aria-label="Dismiss" (click)="notificationService.clear()"
      style="position: absolute; top: 8px; right: 8px;">
      <mat-icon>close</mat-icon>
    </button>
  </div>
}